import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/join/Tittle'
import Register from '../../Components/join/Register'
import Subscribe from '../../Components/join/Subscribe'

const Join = () => {
  return (
    <Main>
        <Tittle/>
        <Register/>
        <Subscribe/>
    </Main>
  )
}

export default Join